<template>
  <v-dialog v-model="showModal" max-width="700px" persistent>
    <v-card flat>
      <v-toolbar dark class="primary">
        <v-btn icon @click.native="showModal = false" dark>
          <v-icon>fa-times</v-icon>
        </v-btn>
        <v-toolbar-title>Dodawanie nowego rozpoznania do wizyty</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-container fluid>
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                  v-model="icd10"
                  id="icd10"
                  name="icd10"
                  :loading="isLoadingICD"
                  :items="icdList"
                  :search-input.sync="icdKeyword"
                  flat
                  no-data-text="Nieznaleziono"
                  hide-details
                  return-object
                  prepend-icon="fa-search"
                  label="Wyszukaj w ICD10"
              >
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-checkbox label="Współistniejące" v-model="concurrent"></v-checkbox>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="selectICD10()">Wybierz</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {icdService} from "@/services";
import swal from "sweetalert";

export default {
  name: "ICD10Picker",
  props: ["visible", "visitid"],
  data() {
    return {
      icd10: null,
      description: null,
      isLoadingICD: false,
      icdList: [],
      icdKeyword: null,
      concurrent: false
    }
  },
  methods: {
    showError(text, close) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {
            if (close) {
              this.showModal = false
            }
          }
      )

    },
    selectICD10() {
      if(this.icd10 === null)
      {
        this.showError("Nic nie wybrano.")
        return
      }
      this.$emit('category_selected', {value: this.icd10.value, concurrent: this.concurrent})
    },
    getICDValues(val)
    {
      if(this.isLoadingICD) return
      this.isLoadingICD = true
      icdService.getAll({query: val, page: 1, limit:20}).then(data => {
        this.icdList = []
        data.data.result.items.forEach(item => {
            this.icdList.push({
              text: item.kod + ' ' +item.opis_icd,
              value: item
            });
        })
        this.isLoadingICD = false
      }).catch(() => {
        this.isLoadingICD = false
        this.showError("Bład pobierania kategorii ICD10")
      })
    }
  },
  computed: {
    showModal: {
      get: function () {
        return this.visible
      },
      set: function (value) {
        if (!value) {
          this.$emit('close')
        }

      }
    }
  },
  watch: {
    icdKeyword(val) {
      if(val)
      {
        this.getICDValues(val)
      }
    }
  }
}
</script>

<style scoped>

</style>